<template>
  <div class="answer-review">
    <!-- 网调开关 -->
    <div class="text-medium text-theme-black-650 leading-22 font-normal">
      <p class="pb-4 text-medium-x text-theme-black-850 leading-22">需人工审核的答卷回收渠道</p>
      <div class="mb-3">
        网络调查
        <el-switch class="ml-3" v-model="peopleExamine" @change="handlerpeopleExamine"></el-switch>
      </div>
      <div v-if="peopleExamine" class="bg-card-bg-gray mr-6 mb-6 px-4 py-3">
        <p class="text-yellow-theme leading-22 text-small">
          <i class="el-icon-warning-outline"></i>
          请务必在限定时间内完成数据审核，超时可能会导致无效数据被平台自动过审。
        </p>
        <el-radio
          v-model="auditRadio"
          @change="handlerpeopleExamine"
          label="enableAuditForRedEnvelopes"
          class="mt-3 text-opacity-65 mr-0"
        >
          仅审核红包答卷，
        </el-radio>
        <el-select v-model="deadlineRed" @change="handlerpeopleExamine" placeholder="" class="bg-white-input" style="width: 64px">
          <el-option v-for="item in 3" :key="item" :label="item" :value="item"> </el-option>
        </el-select>
        <span class="text-medium opacity-65">天内未审核由平台自动过审并发放红包。</span><br />
        <el-radio
          v-model="auditRadio"
          @change="handlerpeopleExamine"
          label="enableNetManualAudit"
          class="mt-3 text-opacity-65 mr-0"
        >
          审核全部答卷，有红包的答卷
        </el-radio>
        <el-select v-model="deadlineAll" @change="handlerpeopleExamine" placeholder="" class="bg-white-input" style="width: 64px">
          <el-option v-for="item in 3" :key="item" :label="item" :value="item"> </el-option>
        </el-select>
        <span class="text-medium opacity-65">天内未审核由平台自动过审并发放红包。</span>
      </div>
      <div class="mb-3">
        面对面访问
        <el-switch class="ml-3" disabled v-model="switchFlag"></el-switch>
      </div>
      <div class="mb-3">
        电话访问
        <el-switch class="ml-3" disabled v-model="switchFlag"></el-switch>
      </div>
      <div>
        委托代理
        <el-switch class="ml-3" disabled v-model="switchFlag"></el-switch>
      </div>
    </div>
    <div class="mt-4">
      <el-button size="small" type="primary" @click="advancedSettings">高级设置</el-button>
      <span class="pl-3">
        <el-button size="small" @click="toAuditData">前往审核</el-button>
      </span>
    </div>

    <!-- 人工审核设置 -->
    <Review v-if="ManualReviewFlag" :visible="true" @close="ManualReviewFlag = false" />
  </div>
</template>

<script>
import GlobalConfig from '@/global/config.js'
import Review from '@/components/manual-review/Review.vue'
import { saveSurveySetting, getFreeLink, changeLinkUrlState } from '@/api/wenjuan/publish.js'

export default {
  name: 'AnswerReview',
  components: { Review },
  props: {
    peopleExa: {
      type: Boolean,
      default: false
    },
    deadlineA: {
      type: Number,
      default: null
    },
    deadlineR: {
      type: Number,
      default: null
    },
    auditRa: {
      type: String,
      default: ''
    },
    preWj: Function
  },
  data() {
    return {
      switchFlag: true,
      peopleExamine: false,
      ManualReviewFlag: false,
      auditRadio: '',
      deadlineRed: 2,
      deadlineAll: 2
    }
  },
  watch: {
    peopleExa(n) {
      this.peopleExamine = n
    },
    deadlineR(n) {
      this.deadlineRed = n
    },
    deadlineA(n) {
      this.deadlineAll = n
    },
    auditRa(n) {
      this.auditRadio = n
    }
  },
  methods: {
    toAuditData() {
      this.$router.push(`/survey/${GlobalConfig.getSurveyId()}/data/data-examine/pending-review`)
    },
    // 答卷审核-第四部分
    handlerpeopleExamine() {
      saveSurveySetting(this.getParams())
        .then(res => {
          if (res.data.code !== 0) {
            return
          }
          this.$message.success('答卷回收渠道保存成功!')
        })
        .catch(e => {
          this.$message.error(e.message)
        })
    },
    getParams() {
      let params = {
        id: GlobalConfig.getSurveyId(),
        otherSetting: {
          enableNetManualAudit: this.peopleExamine,
          enableAuditForRedEnvelopes: this.auditRadio === 'enableAuditForRedEnvelopes',
          auditForRedEnvelopesAutoPassTime: this.auditRadio === 'enableAuditForRedEnvelopes' ? this.deadlineRed : this.deadlineAll
        }
      }
      return params
    },
    //打开高级设置抽屉
    advancedSettings() {
      this.ManualReviewFlag = true
    }
  }
}
</script>
